<template>
<div class="login-page">
    <img v-if="refreshDom" class="login-bg" :src="file[fileId]"/>
    <div class="forget-main">
      <button @click="back" class="forget-back">x</button>
      <div class="forget-title">{{ $t('Auth.findNumber') }}</div>
      <div class="forrget-choose">
      <div class="forget-subtitle">{{ $t('Auth.doYouRemember') }}</div>
        <b-form-group>
          <b-form-radio class="forget-row" v-model="rmber" name="rem" value="true">{{ $t('Auth.rememberEmail') }}</b-form-radio>
          <b-form-radio class="forget-row" v-model="rmber" name="xrem" value="false">{{ $t('Auth.notRememberEmail') }}</b-form-radio>
        </b-form-group>
      </div>
      <div class="forrget-email" v-if="showForm1===1">
        <div class="forget-subtitle">{{ $t('Auth.fullfillEmail') }}</div>
          <b-container fluid>
            <b-row class="forget-row">
              <b-form-input v-model="email" class="forget-input"></b-form-input>
            </b-row>
          </b-container>
        <div class="forget-buttong">
          <b-button class="forget-button" variant="outline-light" @click="reset">{{ $t('Common.reset') }}</b-button>
          <b-button class="forget-button" variant="outline-light" @click="submit1">{{ $t('Common.submit') }}</b-button>
        </div>
      </div>
      <div class="forrget-xemail" v-if="showForm1===2">
        <div class="forget-info" v-if="showForm2">
          <b-container fluid>
            <b-row class="forget-row">
              <b-col sm="4">
                <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'vendor') }}:</label>
              </b-col>
              <b-col sm="8">
                <b-form-input v-model="vendor" class="forget-input"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="forget-row">
              <b-col sm="4">
                <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'cname') }}:</label>
              </b-col>
              <b-col sm="8">
                <b-form-input v-model="cname" class="forget-input"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="forget-row">
              <b-col sm="4">
                <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'ename') }}:</label>
              </b-col>
              <b-col sm="8">
                <b-form-input v-model="ename" class="forget-input"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="forget-row">
              <b-col sm="4">
                <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'phone') }}:</label>
              </b-col>
              <b-col sm="8">
                <b-form-input v-model="phone" class="forget-input"></b-form-input>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="forget-buttong">
          <b-button class="forget-button" variant="outline-light" @click="reset">{{ $t('Common.reset') }}</b-button>
          <b-button class="forget-button" variant="outline-light" @click="submit2">{{ $t('Common.submit') }}</b-button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import axios from '@/api/config'
import { Alert } from 'vue-m-dialog'
import { forgetNumberEmail, forgetNumberxEmail } from '@/api/authAPI'

const ForgetNumber = Vue.extend({
  name: 'ForgetNumber',
  data () {
    return {
      refreshDom: true,
      show: true,
      options: [{ value: 1, text: '总部' }],
      fileId: 1002,
      showForm1: 0,
      showForm2: true,
      showForm3: false,
      rmber: null,
      email: '',
      vendor: '',
      cname: '',
      ename: '',
      phone: '',
      count: 0
    }
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    })
  },
  mounted () {
    if (!this.$store.state.resource.status[this.fileId]) {
      this.$store.dispatch('resource/getFileTypePublic', this.fileId)
    }
  },
  watch: {
    isFileChange () {
      this.refresh()
    },
    rmber () {
      if (this.rmber === 'true') {
        this.showForm1 = 1
        document.getElementsByClassName('forget-main')[0].style.height = '520px'
      } else {
        this.showForm1 = 2
        document.getElementsByClassName('forget-main')[0].style.height = '540px'
        if (this.selected !== null) {
          document.getElementsByClassName('forget-main')[0].style.height = '650px'
        }
      }
    },
    email () {
      if (this.email !== null) {
        this.showForm3 = true
      }
    }
  },
  methods: {
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    },
    reset () {
      this.vendor = ''
      this.email = ''
      this.cname = ''
      this.ename = ''
      this.phone = ''
      this.count = 0
    },
    submit1 () {
      if (this.email !== '') {
        axios.get(forgetNumberEmail + this.email)
          .then((res) => {
            Alert.alert(this.$t('Auth.emaillSuccess', [this.email]))
            this.$router.push({
              name: 'login'
            })
          })
      } else {
        Alert.alert(this.$t('Auth.noEmail'))
      }
    },
    submit2 () {
      if (this.vendor !== '') this.count++
      if (this.cname !== '') this.count++
      if (this.ename !== '') this.count++
      if (this.phone !== '') this.count++
      if (this.count === 4) {
        let formData = new FormData()
        formData.append('vendor', this.vendor)
        formData.append('cname', this.cname)
        formData.append('ename', this.ename)
        formData.append('phone', this.phone)
        axios.post(forgetNumberxEmail, formData,
          {
            transformRequest: [function (newData, headers) {
              return newData
            }]
          })
          .then((res) => {
            if (res.data.error === '01') {
              Alert.alert(this.$t('Auth.submitSuccess'))
              this.$router.push({
                name: 'login'
              })
              this.reset()
            }
          })
      } else {
        Alert.alert(this.$t('Auth.notEnough'))
      }
    },
    back () {
      this.$router.push({
        name: 'login'
      })
    }
  }
})
export default ForgetNumber
</script>

<style>
.login-page {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}
.login-bg {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.forget-back {
  position: absolute;
  font-size: 20px;
  color: white;
  font-weight: 700;
  z-index: 10;
  border: 1px solid white;
  border-radius: 50%;
  height: 38px;
  width: 38px;
  top: 40px;
  left: 30px;
  background-color: #FFFFFF00;
}
.forget-back:focus {
  outline: none;
}
.forget-main {
    position: absolute;
    top: 5%;
    left: 50%;
    width: 60%;
    height: 300px;
    transform: translateX(-50%);
    z-index: 2;
    padding: 30px;
    padding-bottom: 20px;
    background-color: #ffffff28;
    border-radius: 25px;
    transition: all 0.5s ease-in-out;
}
.forget-title {
    z-index: 1;
    font-size: 40px;
    color: white;
}
.forget-subtitle {
    z-index: 1;
    padding-top: 30px;
    font-size: 30px;
    color: white;
}
.forget-vendors {
  width: 40%;
  z-index: 10;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.75);
}
.forget-explain {
    color: white;
    font-size: 16px;
    margin-top: 5px;
}
.forget-info {
    margin-top: 40px;
    text-align: left;
}
.forget-row {
  color: #eeeeee;
  font-size: 20px;
  margin-top: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
.forget-input {
  border: 0;
  font-size: 18px;
  color: #eeeeee;
  background-color: rgba(255, 255, 255, 0.3);
}
.forget-input:focus {
  font-size: 18px;
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.3);
}
.forget-buttong {
  margin-top: 20px;
}
.forget-button {
  margin: 10px;
}
</style>
